import {Route, Routes} from 'react-router-dom';
import './App.css';
import {ProductWeightsOverview} from './view/Overview/ProductWeightsOverview';

function App() {
  return (
    <div id="app_container">
      <Routes>
          <Route path="/product-weights" element={<ProductWeightsOverview />} />
      </Routes>
    </div>
  )
}

export default App
